// @flow

import * as React from 'react';

import { Select } from '@gandi/form';
import { useTranslator } from '@gandi/translate';

import type { GandiFormSelectOption } from 'src/Overview/components/Products/components/types';
import { useAppSelector } from 'src/hooks/useAppSelector';

import { select as selectIDNLanguages } from '../../../modules/selectors/idn';
import type { IDNLangAlpha2Code } from '../../../types';

export type Props = {
  disabled?: boolean,
  onChange?: (option: GandiFormSelectOption<IDNLangAlpha2Code>) => void,
  value?: IDNLangAlpha2Code,
  readOnly?: boolean,
  id: string,
};

export function AlphabetSelect({
  disabled = false,
  onChange,
  value,
  id,
  readOnly,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const values = useAppSelector(selectIDNLanguages);

  const selectedOption = values.find(opt => opt.value === value);

  const isDisabled = disabled || values.length === 0;

  const onSelectChange: (SyntheticEvent<HTMLSelectElement>) => void = evt => {
    const newAlphabet = values.find(
      opt => opt.value === evt.currentTarget.value,
    );
    if (onChange && newAlphabet !== undefined) {
      // $FlowFixMe[incompatible-exact]
      onChange(newAlphabet);
    }
  };

  return (
    <Select
      disabled={isDisabled}
      id={id}
      onChange={e => onSelectChange(e)}
      value={selectedOption?.value}
      // $FlowFixMe[incompatible-type] - IDNLangAlpha2Code is string
      values={values}
      placeholder={__('Select a language')}
      readOnly={readOnly || (!disabled && values.length === 1)}
      variant={['small']}
      //   className={styles.root}
    />
  );
}
